import React from 'react';

import { ChildrenProps } from '../../../utils';
import { BannerType } from '../Banner/Banner';
import { Banner } from '../index';

type Props = ChildrenProps;

const BannerAlert = ({ children }: Props) => {
  return (
    <>
      <Banner type={BannerType.ALERT}>{children}</Banner>
    </>
  );
};

export default BannerAlert;
